module.exports = __webpack_public_path__ + "img/review-fail.4b574288.png";